const CLICK_COLLECT = 'Collect';
const STANDARD = 'Standard';
const EXPRESS = 'Express';
const SAME_DAY = 'SameDay';

export default {CLICK_COLLECT, STANDARD, EXPRESS, SAME_DAY}